
            const data = {"name":"glyph/16/check-green","data":{"width":"16","height":"16","viewBox":"0 0 16 16","data":"<path pid=\"0\" d=\"M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11.4 3.6 8 5 6.6l2 2 4-4L12.4 6 7 11.4z\" class=\"nc-icon-wrapper\" _fill=\"#1A5B0B\"/>","originalColors":[{"type":"fill","color":"#1A5B0B"}],"stopColors":[]}}
        
                    module.exports = data
                    